import { useState, useEffect } from 'react';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import { _UBLInvoice } from '../../../../../core/services/dataBean/EntityCatalog';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const SelectAccountantConceptCatalogForSupplierInvoice = ({ idSelector, onChange, label }: Props) => {

    const service = useDataBean(_UBLInvoice);
    const [lista, setLista] = useState([]);
    const [id, setID] = useState(idSelector ?? "");

    useEffect(() => {
        if (idSelector != id) {
            setID(idSelector);
        }
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: any) => {
        if (e == "") {
            setID("");
            onChange(null)
        }
        else {
            setID(parseInt(e));
            onChange(e);
        }
    }

    const getLista = () => {
        service.instance.getAccountantConceptCatalogForSupplierInvoice().then(
            (resp: any) => {

                if (resp) {
                    setLista(resp);
                }
            }
        );
    }

    return (
        <>
            <label>{label ?? "Concepto de Ingreso de Facturación Proveedor"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={""}>...</option>
                {lista &&
                    lista.map((item: any, _i) => {
                        return (
                            <option key={_i} value={item.DataBeanProperties.IDAccountantConcept} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}